module.exports = require("kaitai-struct");